import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import GlobalButton from "../CustomButton";
import { CURRENCY } from "../../constants/Variables";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "550px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
  "& .MuiTableContainer-root .MuiTable-root .MuiTableHead-root": {
    backgroundColor: "#f3f3f3",
  },
  "& .MuiTableCell-root ": {
    padding: "8px 16px",
  },
}));

const renderSizes = (data) => {
  return (
    <Stack direction={"row"} alignItems={"center"} flexWrap={"wrap"} gap={2}>
      {data?.row?.size?.map((val, index) => {
        return (
          <Stack
            key={index}
            direction={"row"}
            border={"1px solid grey"}
            borderRadius={"6px"}
            overflow={"hidden"}
          >
            <Box p={1} width={60} bgcolor={"#d7d7d7"} textAlign={"center"}>
              {val.name}
            </Box>
            <Box width={50} p={1} textAlign={"center"}>
              {val.quantity}
            </Box>
          </Stack>
        );
      })}
    </Stack>
  );
};
const renderWeight = (data) => {
  return (
    <Stack direction={"row"} alignItems={"center"} flexWrap={"wrap"} gap={2}>
      {data?.row?.weigth?.map((val, index) => {
        return (
          <Stack
            key={index}
            direction={"row"}
            border={"1px solid grey"}
            borderRadius={"6px"}
            overflow={"hidden"}
          >
            <Box p={1} width={"auto"} bgcolor={"#d7d7d7"} textAlign={"center"} 
              borderRight={"1px solid grey"}
            
            >
              {val.name}
            </Box>
            <Box
              width={"auto"}
              p={1}
              textAlign={"center"}
              borderRight={"1px solid grey"}
            >
              {val.price} {CURRENCY}
            </Box>
            <Box width={"auto"} p={1} textAlign={"center"}>
              Qty: {val.quantity}
            </Box>
          </Stack>
        );
      })}
    </Stack>
  );
};

const renderColors = (data) => {
  return (
    <TableContainer component={"paper"}>
      <Table sx={{ marginTop: 2 }}>
        <TableHead>
          <TableRow>
            <TableCell>Color</TableCell>
            <TableCell align="center">Color Family</TableCell>
            <TableCell align="center">Quantity</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.row?.color?.map((colorObj, colorIndex) => (
            <TableRow key={colorIndex}>
              <TableCell>
                <Box
                  height={30}
                  width={30}
                  borderRadius={"50%"}
                  bgcolor={colorObj.color}
                  border={colorObj.color === "#ffffff" ? "1px solid #000" : ""}
                />
              </TableCell>
              <TableCell align="center">{colorObj.colorName}</TableCell>
              <TableCell align="center">{colorObj.quantity}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
const renderSizesColors = (data) => {
  return data?.row?.sizeWithColor?.map((item, mainIndex) => {
    return (
      <Box key={mainIndex} px={"3px"} mb={1}>
        <Stack
          direction={"row"}
          border={"1px solid grey"}
          borderRadius={"6px"}
          overflow={"hidden"}
          width={"max-content"}
          my={1}
        >
          <Box p={1} width={60} bgcolor={"#d7d7d7"} textAlign={"center"}>
            Size
          </Box>
          <Box width={50} p={1} textAlign={"center"}>
            {item.name}
          </Box>
        </Stack>
        <TableContainer component={"paper"}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Color</TableCell>
                <TableCell align="center">Color Family</TableCell>
                <TableCell align="center">Quantity</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {item?.colors.map((colorObj, colorIndex) => (
                <TableRow key={colorIndex}>
                  <TableCell>
                    <Box
                      height={30}
                      width={30}
                      borderRadius={"50%"}
                      bgcolor={colorObj.color}
                      border={
                        colorObj.color === "#ffffff" ? "1px solid #000" : ""
                      }
                    />
                  </TableCell>
                  <TableCell align="center">{colorObj.colorName}</TableCell>
                  <TableCell align="center">{colorObj.quantity}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  });
};

let paramsData = {};

const ProductDetailDialog = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
    },
    closeDialog() {
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <IconButton
        sx={{ position: "absolute", top: "5px", right: "5px" }}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle
        variant="h1"
        fontWeight={600}
        fontSize={"1.5rem"}
        fontFamily={"inter"}
        sx={{ m: 0, p: 2 }}
        id="customized-dialog-title"
      >
        {paramsData.type === "size"
          ? "Available Sizes"
          : paramsData.type === "color"
          ? "Available Colors"
          : paramsData.type === "sizeWithColor"
          ? "Available Sizes With Colors"
          : "Available weight"}
      </DialogTitle>
      <DialogContent dividers>
        {paramsData?.type === "size" &&
          paramsData?.row.size?.length > 0 &&
          renderSizes(paramsData)}
        {paramsData?.type === "color" &&
          paramsData?.row.color?.length > 0 &&
          renderColors(paramsData)}
        {paramsData?.type === "sizeWithColor" &&
          paramsData?.row.sizeWithColor?.length > 0 &&
          renderSizesColors(paramsData)}
        {paramsData?.type === "weigth" &&
          paramsData?.row.weigth?.length > 0 &&
          renderWeight(paramsData)}
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant={"custom_outlined"}
          btnText={"Close"}
          handleClickBtn={handleClose}
          styleProps={{
            height: 38,
            width: 100,
            borderRadius: "6px",
          }}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default ProductDetailDialog;
